import join from 'url-join';

import { http } from '../../util/index';
import { flatten } from '../../util/array/flatten';

const api2 = join(import.meta.env.VITE_API2_URL, 'v1');

export const getOrderLineItems = async orderId => {
  return http
    .get(join(api2, `/orders/lineItems?filter=orderId(${orderId})?count=100&anchor=0`))
    .then(({ data: { objects } }) => {
      // sort by productCode to ensure consistent order after deleting line items
      const sortedObjects = [...objects].sort((a, b) => {
        if (a.productCode < b.productCode) return -1;
        if (a.productCode > b.productCode) return 1;
        return 0;
      });
      return sortedObjects;
    });
};

export const updateLineItemSizes = async ({ orderId, lineItemId, sizes }) => {
  return http
    .patch(join(api2, `/orders/${orderId}/lineItems/${lineItemId}`), {
      sizes
    })
    .then(({ data }) => data);
};

export const deleteLineItem = async ({ orderId, lineItemId }) => {
  return http.delete(join(api2, `/orders/${orderId}/lineItems/${lineItemId}`)).then(({ data }) => data);
};

export const resubmitOrder = async orderId => {
  return http.post(join(api2, '/orders/resubmit'), { orderIds: [orderId] });
};

export const handleResubmitOrders = async orderIds => {
  const payload = { orderIds };

  return http.post(`${api2}/orders/resubmit`, payload);
};

export const handleFetchAllTroubledOrders = async ({ totalResources, sortQueryParams, filterQueryParams }) => {
  const url = join(api2, `admin/troubledOrders/?count=100${sortQueryParams}${filterQueryParams}`);
  const numberOfRequests = Math.ceil(totalResources / 100);

  const subsequentRequests = [];
  let anchor = 0;
  /* eslint-disable no-await-in-loop */
  for (let i = 0; i < numberOfRequests; i += 6) {
    const subsequestRequestsGroup = [];
    const limit = Math.min(6, numberOfRequests - i);
    for (let j = 0; j < limit; j++) {
      subsequestRequestsGroup.push(http.get(`${url}&anchor=${anchor}`));
      anchor += 100;
    }

    await Promise.all(subsequestRequestsGroup)
      .then(responses => responses.map(r => r.data.objects))
      .then(result => subsequentRequests.push(flatten(result)));
  }
  return flatten(subsequentRequests);
};
